import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "filter form" }
const _hoisted_2 = {
  class: "item",
  "data-size": "medium"
}
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  class: "item",
  "data-cta": "multi"
}
const _hoisted_5 = { class: "cta" }
const _hoisted_6 = {
  key: 0,
  class: "cta"
}

import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectFilterBox',
  props: {
    accentColor: {}
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const router = useRouter();
const localizer = Localizer;
const searchText = ref<string | null>(null);
const isProject = ref(true);
const isAsset = ref(false);

onMounted(() => {
	let searchObj = JSON.parse(window.sessionStorage.getItem("ProcessSearch"));
	window.sessionStorage.removeItem("AssetSearch");

	if (route.query.searchtext) {
		searchText.value = <string>route.query.searchtext;
	} else if (searchObj?.searchtext) {
		searchText.value = searchObj.searchtext;
	}

	if (route.query.isproject) {
		isProject.value = route.query.isproject === "true";
	} else if (searchObj?.isproject) {
		isProject.value = searchObj.isproject;
	}

	if (route.query.isasset) {
		isAsset.value = route.query.isasset === "true";
	} else if (searchObj?.isasset) {
		isAsset.value = searchObj.isasset;
	}

	if (searchObj != null && !route.query.searchtext && !route.query.isproject && !route.query.isasset) {
		router.replace({ path: window.location.pathname, query: { searchtext: searchText.value, isproject: isProject.value ? "true" : "false", isasset: isAsset.value ? "true" : "false" } }).catch(() => { });
	}
});

function resetSearch() {
	searchText.value = null;

	setSearch();
}

function setSearch() {
	const query = { 
		searchtext: searchText.value, 
		isproject: isProject.value ? "true" : "false", 
		isasset: isAsset.value ? "true" : "false" 
	};
	
	window.sessionStorage.setItem("ProcessSearch", JSON.stringify(query));

	const params = new URLSearchParams();
	if (searchText.value) 
	{
		params.set('searchtext', searchText.value)
	};
	params.set('isproject', isProject.value ? "true" : "false");
	params.set('isasset', isAsset.value ? "true" : "false");
	
	window.location.href = window.location.pathname + '?' + params.toString();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "textbox",
        type: "text",
        placeholder: _unref(localizer).get('PrivateArea.Common.ProjectDetail_FilterBox_SearchText_Placeholder'),
        onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (setSearch()), ["enter"])),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event))
      }, null, 40, _hoisted_3), [
        [_vModelText, searchText.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setSearch())),
          "data-size": "small",
          style: _normalizeStyle([{ 'background-color': __props.accentColor }])
        }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProjectDetail_FilterBox_SearchButton")), 5)
      ]),
      (searchText.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "button",
              "data-type": "link",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (resetSearch()))
            }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.ProjectDetail_FilterBox_ResetFilters")), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})